// The gateway issues a signed token when it creates a submission and requires it, with the
// resident's session, to link that submission to the resident. Both names are the gateway's contract.
export const SUBMISSION_LINK_TOKEN_HEADER = 'x-submission-link-token';
const LINK_TOKEN_RESPONSE_FIELD = 'linkToken';

export const readSubmissionLinkToken = (createResponse: unknown): string | undefined => {
  if (typeof createResponse !== 'object' || createResponse === null) return undefined;
  const token: unknown = Reflect.get(createResponse, LINK_TOKEN_RESPONSE_FIELD);
  return typeof token === 'string' && token ? token : undefined;
};
